module.exports = __webpack_public_path__ + "static/media/Pham-Huy-Hieu.f74436e2.png";